import { Outlet } from "react-router-dom";
import TopNav from "ui/dashboard/topnav";
import DatabaseList from "ui/database/database-list";
import DatabaseProvider from "context/DatabaseContext";
import "./page.scss";

export default function Layout() {
  return (
    <>
      <DatabaseProvider>
        <TopNav title="Database" />
        <div className="flex h-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl mr-6 mb-6">
          <DatabaseList />
          <div className="flex-grow p-6">
            <Outlet />
          </div>
        </div>
      </DatabaseProvider>
    </>
  );
}
